import { render, staticRenderFns } from "./ViewTaskModal.vue?vue&type=template&id=04f48c4f&scoped=true"
import script from "./ViewTaskModal.vue?vue&type=script&lang=js"
export * from "./ViewTaskModal.vue?vue&type=script&lang=js"
import style0 from "./ViewTaskModal.vue?vue&type=style&index=0&id=04f48c4f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f48c4f",
  null
  
)

export default component.exports